














import Vue, { PropOptions } from 'vue';
import BillingService, { BillingAccount, Invoice } from '~/services/BillingService';
import BaseCard from '../components/BaseCard.vue';
import InvoiceTable from '../components/InvoiceTable.vue';

export default Vue.extend({
    name: 'Invoices',
    components: {
        BaseCard,
        InvoiceTable,
    },
    props: {
        billingAccount: {
            type: Object,
            required: true,
        } as PropOptions<BillingAccount>,
    },
    data() {
        return {
            loading: true,
            error: false,
            service: new BillingService(),

            invoices: [] as Invoice[],
        };
    },
    computed: {
        empty(): string | null {
            if (this.loading || this.error) return null;
            return !this.invoices.length
                ? this.$t('plansAndBilling.invoices.noInvoices').toString()
                : null;
        },
    },
    methods: {
        getInvoices() {
            this.loading = true;
            this.service
                .getAllInvoices(this.billingAccount.id)
                .then(invoices => (this.invoices = invoices))
                .catch(err => {
                    console.error(err);
                    this.error = true;
                })
                .finally(() => (this.loading = false));
        },
    },
    mounted() {
        this.getInvoices();
    },
});
